<template>
  <div class="step step_0" :class="{ 'form__step_hidden': step != number }" :aria-labelledby="`step${number}-title`">
    <transition-group tag="div" name="fade" class="transitiongroup" ref="transitiongroup">
      <RadioGroup :key="1" v-model="stepsdata[number][names[0]]" :grid="true" :name="names[0]" title="Вы являетесь клиентом Росбанка?*" :required="true" :values="['Нет', 'Росбанк Дом', 'Дельта кредит', 'Росбанк', 'Другой банк']" />
      <RadioGroup :key="2" v-show="stepsdata[number][names[0]] && !buttonBlock" v-model="stepsdata[number][names[1]]" :name="names[1]" title="Причина обращения*" :required="true" :values="values1" />
      <RadioGroup :key="3" v-show="stepsdata[number][names[1]] && !buttonBlock" v-model="stepsdata[number][names[2]]" :name="names[2]" title="Выберете варианты страхования*" :required="true" :values="values2" />

      <transition-group ref="transitiongroup2" tag="div" name="fade" class="transitiongroup" :key="99" :style="{ 'height': (!this.fileNeeded || buttonBlock) ? '0px !important' : '' }">
        <RadioGroup v-if="fileNeeded && !buttonBlock" :key="4" v-show="stepsdata[number][names[2]] && !buttonBlock" v-model="stepsdata[number][names[3]]" :name="names[3]" :grid="true" title="Необходимо загрузить отчёт об оценке недвижимости" :required="true" :values="['Прикрепить файл', 'Указать ссылку']" />
        <transition-group ref="switchwrap" tag="div" name="fade" class="switchwrap" :key="100">
          <Droparea v-if="fileNeeded && !buttonBlock" v-model="stepsdata[number][names[4]]" :key="5" :style="{ 'position': (stepsdata[this.number][this.names[3]] != 'Прикрепить файл') ? 'absolute' : 'static' }" v-show="stepsdata[number][names[3]] == 'Прикрепить файл'" :multiple="true" :required="true" :name="names[4]" />
          <LinkInput :btn="false" v-if="fileNeeded && !buttonBlock" :errorcont="errorcont" :key="6" :style="{ 'position': (stepsdata[this.number][this.names[3]] != 'Указать ссылку') ? 'absolute' : 'static' }" v-show="stepsdata[number][names[3]] == 'Указать ссылку'" v-model="stepsdata[number][names[5]]" :name="names[5]" :required="false" />
        </transition-group>
      </transition-group>
    </transition-group>
    <div class="form__btns">
      <Btn @click.native.prevent="$store.commit('nextStep')" :disabled="!filled() || step != number || buttonBlock">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from './ui/Btn.vue'
import RadioGroup from './RadioGroup.vue'
import { mapState } from 'vuex'
import Droparea from './Droparea.vue'
import LinkInput from './LinkInput.vue'
import smoothReflow from 'vue-smooth-reflow'

export default {
  data: () => ({
    names: ['isourclient', 'reason', 'insuranceproduct', 'report_type', 'report[]', 'report_link'],
    values1: [`Ранее был расторгнут договор с\xa0компанией Росбанк Страхование по\xa0данному ипотечному договору`, 'Впервые обращаюсь за\xa0сменой страховщика по\xa0данному ипотечному договору'],
    values2: ['Страхование Жизни', 'Страхование Жизни и Недвижимости'],
    delay: false,
    errorcont: {},
    timer: undefined,
    buttonBlock: false
  }),
  components: { Btn, RadioGroup, Droparea, LinkInput },
  props: {
    number: { type: Number, default: 0 }
  },
  mixins: [smoothReflow],
  mounted() {
    this.$smoothReflow({
      el: this.$refs.transitiongroup.$el,
      transition: 'height .5s'
    })
    this.$smoothReflow({
      el: this.$refs.transitiongroup2.$el,
      transition: 'height .5s'
    })
    for (let el of this.$el.querySelectorAll('.switchwrap'))
      this.$smoothReflow({ el, transition: 'height .5s' })

  },
  methods: {
    filled() {
      for (let name of this.activeFields)
        if (!this.stepsdata[this.number][name] || this.errorcont[name])
          return false
      return true
    }
  },
  computed: {
    ...mapState(['stepsdata', 'step']),
    fileNeeded() {
      return this.stepsdata[this.number][this.names[1]] == this.values1[1]
        && this.stepsdata[this.number][this.names[2]] == this.values2[1]
    },
    activeFields() {
      let r = this.names.map(el => el)
      if (!this.fileNeeded)
        r = r.filter((el, i) => ![3, 4, 5].includes(i))
      else {
        let v = []
        if (this.choose == 1)
          v = [5]
        if (this.choose == 2)
          v = [4]
        r = r.filter((el, i) => !v.includes(i))
      }
      return r
    },
    selectChoice() {
      return this.stepsdata[this.number][this.names[0]]
    },
    choose() {
      if (this.stepsdata[this.number][this.names[3]] == 'Прикрепить файл')
        return 1
      if (this.stepsdata[this.number][this.names[3]] == 'Указать ссылку')
        return 2
      return 0
    }
  },
  watch: {
    selectChoice(v) {
      if (v && !['Росбанк Дом', 'Дельта кредит'].includes(v)) {
        let vals = ['Нет', 'Росбанк', 'Другой банк'],
          actions = ['1etap_net', '1etap_rosbank2', 'drugoy_bank_1']

        let ymaction
        for (let i = 0; i < vals.length; i++)
          if (v == vals[i]) {
            ymaction = actions[i]
            break
          }

        this.$store.dispatch('throwSuccess', {
          type: 'redirect',
          title: 'Переход',
          text: 'Для обращения перейдите на форму обратной связи',
          redirect_url: 'https://rosbankinsurance.ru/help/feedback/personalDataForm',
          ymaction: ymaction
        })
        this.buttonBlock = true
      } else {
        this.buttonBlock = false
      }
    },
    choose(v, old) {
      if (old == 0) return
      if (v == 1)
        this.delay = 1
      if (v == 2)
        this.delay = 2
      clearTimeout(this.timer)
      this.timer = setTimeout(() => this.delay = 0, 400)
    }
  }
}
</script>

<style lang="sass">
.step
  >*:not(:first-child), .transitiongroup>*
    padding-top: var(--basespace)
  .transitiongroup
    padding-top: 0
    display: block
    position: relative
  >.transitiongroup:first-child>*:first-child
    padding-top: 0
.switchwrap
  position: relative
  padding-top: 0 !important
  p.smallfont
    margin-bottom: 0
  >*
    padding-top: var(--basespace)
    top: 0
</style>